import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FreeBannerComponent } from './components/free-banner/free-banner.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [FreeBannerComponent],
  exports: [FreeBannerComponent],
})
export class FreeBannerModule { }
